// Cena 5 — A conversa (áudio ~20s)
// Um chat fictício ganha vida na área direita: o cliente pergunta, a
// resposta é digitada sozinha, o cursor clica em ENVIAR e, ao final,
// em RESOLVER — miras sempre em seletores reais [data-demo=...].
const MAIN = "[data-tour='main-content']";
const CHAT = "[data-demo='chat']";
const SEND = "[data-demo='send']";
const RESOLVE = "[data-demo='resolve']";

const MSG_IN = { from: "in", text: "Oi! Vocês entregam hoje? 🙂" };
const MSG_OUT_1 = { from: "out", text: "Entregamos sim, até as 18h! 🚚" };
const MSG_OUT_2 = { from: "out", text: "Quer fazer o pedido?" };
const MSG_IN_2 = { from: "in", text: "Perfeito, quero sim!" };

export default async function chat(ctx) {
	// "Dentro do ticket, é igualzinho ao WhatsApp..."
	await ctx.waitFor(MAIN);
	ctx.spotlight(MAIN);
	await ctx.wait(600);

	// cursor descansa à esquerda para não tampar o chat que vai surgir
	await ctx.cursorTo({ sel: MAIN, ax: 0.26, ay: 0.45 }, { duration: 800 });

	const panel = ctx.mount("chatPanel", MAIN, {
		contact: "Maria Souza",
		initial: "M",
		color: "#8B5CF6",
		items: [MSG_IN],
		style: {
			position: "absolute",
			right: 20,
			top: 60,
			width: "52%",
			minWidth: 360,
			height: "72%",
		},
	});
	await ctx.waitFor(CHAT);
	await ctx.wait(1400);

	// "...você manda texto, áudio, foto, emoji..." — cliente digitando
	ctx.update(panel, { items: [MSG_IN, { from: "typing" }] });
	await ctx.wait(1200);

	// "...tudo em tempo real!" — resposta chega e outra já vai sendo digitada
	ctx.update(panel, {
		items: [MSG_IN, MSG_OUT_1],
		inputText: MSG_OUT_2.text,
		inputDone: false,
	});
	await ctx.wait(2200);

	// cursor vai até o botão de enviar e clica — a mensagem sai
	await ctx.waitFor(SEND);
	await ctx.cursorTo(SEND, { duration: 850 });
	await ctx.click(SEND);
	ctx.update(panel, {
		items: [MSG_IN, MSG_OUT_1, MSG_OUT_2],
		inputText: "",
		inputDone: true,
	});
	await ctx.wait(1000);

	// cliente confirma
	ctx.update(panel, { items: [MSG_IN, MSG_OUT_1, MSG_OUT_2, MSG_IN_2] });
	await ctx.wait(2200);

	// "E quando terminar o atendimento, clique em Resolver."
	await ctx.waitFor(RESOLVE);
	await ctx.cursorTo(RESOLVE, { duration: 1000 });
	await ctx.wait(300);
	await ctx.click(RESOLVE);

	ctx.update(panel, { resolved: true });
	await ctx.wait(1300);

	// "Assim a sua fila fica sempre limpa... e nenhum cliente sem resposta."
	const toast = ctx.mount("toast", MAIN, {
		icon: "✨",
		text: "Fila limpa: nenhum cliente sem resposta!",
	});
	await ctx.wait(3000);
	ctx.unmount(toast);

	ctx.spotlight(null);
	await ctx.cursorTo({ sel: MAIN, ax: 0.35, ay: 0.6 }, { duration: 800 });
	await ctx.wait(400);
}
